/**
 * @purpose: mengelola halaman daftar purchase item agar runtime pencarian, refresh, dan pagination berjalan stabil.
 * @called_by: views/app_item/item_view.html.
 * @deps: AngularJS app, _API_URL, modalService, urlServices, _VAR_GLOBAL, toaster.
 * @public: itemViewCtrl.
 * @side_effects: memuat data item purchasing dari API dan menghapus item saat diminta user.
 */
app.controller('itemViewCtrl', ['$scope', '_API_URL', 'modalService', 'urlServices', '_VAR_GLOBAL', 'toaster', function ($scope, _API_URL, modalService, urlServices, _VAR_GLOBAL, toaster) {
    $scope.filter = '';
    $scope.dataList = {
        totalItems: 0,
        summary: {},
        data: []
    };
    $scope.paginationOptions = {
        pageNumber: 1,
        pageSize: _VAR_GLOBAL.limit,
        sort: null
    };

    function normalizeError(err, fallbackMessage) {
        if (!err) {
            return fallbackMessage || 'Error tidak terdeteksi';
        }
        if (err.err) {
            return err.err;
        }
        if (err.message) {
            return err.message;
        }
        return String(err);
    }

    function getResponseData(result) {
        return result && result.data ? result.data : result;
    }

    $scope.edit = function (item) {
        var kode = item.KodeBarang || item.kodebarang;
        window.location = _API_URL + 'purchase-item-entry?screen=item&isedit=true&kodebarang=' + kode;
    };

    $scope.detail = function (item) {
        var kode = item.KodeBarang || item.kodebarang;
        window.location = _API_URL + 'purchase-item-entry?screen=item&isedit=true&isview=true&kodebarang=' + kode;
    };

    $scope.hapus = function (item) {
        var kode = item.KodeBarang || item.kodebarang;
        modalService.showModal({}, {
            headerText: 'Hapus Barang',
            bodyText: 'Apakah Anda yakin ingin menghapus [' + kode + '] ?'
        }).then(function (result) {
            if (!result) {
                return;
            }

            urlServices.simpanData('api/purchase-item-delete', { KodeBarang: kode }, function (err) {
                if (err) {
                    return toaster.pop('error', 'Item', normalizeError(err, 'Data gagal dihapus'));
                }

                toaster.pop('success', 'Item', 'Data berhasil dihapus');
                return $scope.viewData(1);
            });
        });
    };

    $scope.getData = function (pageSize, page, searchText) {
        var query = [
            'limit=' + encodeURIComponent(pageSize),
            'pg=' + encodeURIComponent(page)
        ];

        if (searchText) {
            query.push('term=' + encodeURIComponent(String(searchText).toLowerCase()));
        }

        return urlServices.ambilData('api/purchase-item?' + query.join('&'), {}, function (err, result) {
            var responseData;

            if (err) {
                $scope.dataList.totalItems = 0;
                $scope.dataList.data = [];
                return toaster.pop('error', 'Item', normalizeError(err, 'Gagal mengambil data item'));
            }

            responseData = getResponseData(result) || {};
            $scope.dataList.totalItems = responseData.total || 0;
            $scope.dataList.data = responseData.dt || [];
        });
    };

    $scope.viewData = function (page) {
        $scope.paginationOptions.pageNumber = page || 1;
        return $scope.getData($scope.paginationOptions.pageSize, $scope.paginationOptions.pageNumber, $scope.filter || '');
    };

    $scope.refreshData = function () {
        return $scope.viewData($scope.paginationOptions.pageNumber || 1);
    };

    $scope.excelReport = function () {
        toaster.pop('info', 'Item', 'Export Excel belum tersedia');
    };

    $scope.viewData(1);
}]);
